/**
 * js_error collector'i (opsiyonel).
 * Musterinin kendi sayfasindaki JS hatalarini raporlar.
 * Ayni hata mesaji oturum icinde bir kez gonderilir (dedupe).
 */
import { AUTO_EVENTS } from "../events";

const MAX_ERRORS_PER_PAGE = 10;

class ErrorsCollector {
    constructor(tracker) {
        this.tracker = tracker;
        this.seen = [];
    }

    start() {
        const self = this;

        window.addEventListener("error", function (event) {
            // Kaynak yukleme hatalari (img, script) ayri bir konu; sadece JS hatalarini aliyoruz.
            if (!event || !event.message) return;
            self.report(event.message, event.filename, event.lineno, event.colno);
        });

        window.addEventListener("unhandledrejection", function (event) {
            if (!event) return;
            const reason = event.reason;
            const message = reason && reason.message ? reason.message : String(reason || "unhandled rejection");
            self.report(message, "", 0, 0);
        });
    }

    report(message, source, line, column) {
        if (this.seen.length >= MAX_ERRORS_PER_PAGE) return;
        const text = String(message || "").slice(0, 300);
        if (!text) return;
        const key = text + "|" + String(source || "");
        if (this.seen.indexOf(key) !== -1) return;
        this.seen.push(key);

        this.tracker.emit(
            AUTO_EVENTS.JS_ERROR,
            {
                message: text,
                source: String(source || "").slice(0, 300),
                line: line || 0,
                column: column || 0,
            },
            {
                error: { message: text, source: String(source || "").slice(0, 300) },
            }
        );
    }
}

export default ErrorsCollector;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/errors.js
// module id = null
// module chunks = 